import React from "react";
import App from "../App";
import LoginPage from "./LoginPage";
import { useAuth0 } from '@auth0/auth0-react';

const AppLogin = () => {

	const { isAuthenticated, isLoading } = useAuth0();
	const loggedIn = (<App />);
	const loggedOut = (<LoginPage/>);

	if(isLoading) {
		return <div style={{backgroundColor: '#333a41', height: '100vh'}}></div>
	}

	return (
		<>
			{ isAuthenticated ? loggedIn : loggedOut}
		</>
	);
};

export default AppLogin;